import { Dispatch } from 'react'

import { Tabs as F0Tabs } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export type DetailTab = 'metrics' | 'assignments'

interface TabsProps {
  activeTab: DetailTab
  onTabChange: Dispatch<DetailTab>
}

export function Tabs({ activeTab, onTabChange }: TabsProps) {
  const tabs = [
    {
      id: 'metrics' as const,
      label: i18n.t('incentives.detail.metrics.title'),
    },
    {
      id: 'assignments' as const,
      label: i18n.t('incentives.detail.assignments.title'),
    },
  ]

  return <F0Tabs tabs={tabs} activeTabId={activeTab} setActiveTabId={onTabChange} />
}
